import { useState, useEffect } from 'react';

import { useArrayQueryParam } from './useQueryParam';
import { getTagsByType } from 'features/tags/api';
import { TagType, Tag } from 'types';

export const useTags = (type: TagType) => {
  const [tags, setTags] = useState<Tag[]>([]);
  const [isLoading, setLoadingState] = useState<boolean>(false);

  const tagsSelected = useArrayQueryParam<Tag['name']>(
    'tags',
    tags?.map(({ name }) => name) || [],
    [],
  );

  useEffect(() => {
    setLoadingState(true);
    const getData = async () => {
      const options = await getTagsByType(type, tagsSelected);
      setTags(options);
      setLoadingState(false);
    };
    getData();
  }, [type, tagsSelected.length]);

  return {
    isLoading,
    tags,
    tagsSelected
  }
}